export const VMWARE_BASE_RATES = {
  WITH_MANAGED_SERVICES: 300,
  WITHOUT_MANAGED_SERVICES: 200,
} as const;
